export const Component = (properties) => (target) => {
    const prototype = target.prototype;
    // Set properties using Object.defineProperty to avoid read-only issues
    Object.defineProperty(prototype, 'controller', {
        value: target,
        writable: true,
        configurable: true,
    });
    Object.defineProperty(prototype, 'bindings', {
        value: {},
        writable: true,
        configurable: true,
    });
    // Assign properties directly instead of reassigning prototype
    Object.assign(prototype, properties);
    if (!prototype.controllerAs) {
        prototype.controllerAs = '$ctrl';
    }
    //Bindins with <? type
    if (properties.inputs) {
        properties.inputs.forEach((element) => {
            prototype.bindings[element] = '<?';
        });
    }
    //Bindins with &? type
    if (properties.outputs) {
        properties.outputs.forEach((element) => {
            prototype.bindings[element] = '&?';
        });
    }
    return prototype;
};
